module.exports = __webpack_public_path__ + "static/Information-94cb343a0ea77eeae3f66b10f7ec52c1.png";